module.exports = __webpack_public_path__ + "static/media/JSNMC4.6e7b8a5b.png";